import React from "react";
import {
  List,
  ListItemText,
  Typography,
  ListItemSecondaryAction,
  Divider,
  ListItem,
  Box,
} from "@material-ui/core";

const keyToTitle = (key) => key.replace(/([A-Z])/g, " $1").trim();

const isURL = (value) => {
  var res = value.match(
    /(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
  );
  return res !== null;
};

export function KeyValueArray(props) {
  const { data } = props;
  // const preventDefault = (event) => event.preventDefault();

  return (
    <>
      <List>
        {data.map((obj, index) => (
          <Box key={index}>
            <ListItem>
              <ListItemText>
                <Typography className="text-capitalize">
                  {obj.title ? obj.title : keyToTitle(obj.key)}
                </Typography>
              </ListItemText>
              <ListItemSecondaryAction>
                <Typography>
                  {obj.value === undefined || obj.value === null ? (
                    "--"
                  ) : typeof obj.value === "string" && isURL(obj.value) ? (
                    <a
                      href={"https://" + obj.value}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {obj.value}
                    </a>
                  ) : obj.key.startsWith("rankings") ? (
                    <>
                      <b>#{obj.value.value}</b>{" "}
                      <span>of {obj.value.total}</span>
                    </>
                  ) : (
                    obj.value.toString()
                  )}
                </Typography>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider />
          </Box>
        ))}
      </List>
    </>
  );
}
